import { memo } from "react";

// Enhanced skeleton shimmer effect for loading states
// Uses CSS animation defined in index.css

const SkeletonCard = memo(({ variant = "default" }) => {
  if (variant === "feed") {
    // Mobile feed skeleton - horizontal layout
    return (
      <div className="glass rounded-xl p-4 flex gap-4">
        {/* Image placeholder */}
        <div className="w-20 h-20 rounded-lg skeleton-shimmer flex-shrink-0" />
        {/* Content placeholder */}
        <div className="flex-1 space-y-2">
          <div className="h-5 skeleton-shimmer rounded w-3/4" />
          <div className="h-4 skeleton-shimmer rounded w-1/2" />
          <div className="flex gap-4 mt-2">
            <div className="h-6 skeleton-shimmer rounded w-16" />
            <div className="h-6 skeleton-shimmer rounded w-20" />
          </div>
        </div>
      </div>
    );
  }

  // Default grid card skeleton - matches EventCard layout exactly
  return (
    <div 
      className="relative rounded-2xl overflow-hidden border border-border/50 bg-card"
      data-testid="event-card-skeleton"
    >
      {/* Image Area */}
      <div className="relative aspect-[4/3]">
        <div className="absolute inset-0 skeleton-shimmer" />
        
        {/* Price Tag Skeleton */}
        <div className="absolute top-3 right-3">
          <div className="w-12 h-6 rounded-full skeleton-shimmer" />
        </div>
        
        {/* Badge Skeleton */}
        <div className="absolute bottom-3 left-3">
          <div className="w-16 h-5 rounded-full skeleton-shimmer" />
        </div>
      </div>
      
      {/* Content Area */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <div className="h-5 w-3/4 rounded skeleton-shimmer" />
        
        {/* Location & Date */}
        <div className="flex items-center gap-2">
          <div className="h-4 w-20 rounded skeleton-shimmer" />
          <div className="h-4 w-24 rounded skeleton-shimmer" />
        </div>
        
        {/* Artist */}
        <div className="h-4 w-1/2 rounded skeleton-shimmer" />
        
        {/* Audio Player Skeleton */}
        <div className="flex items-center gap-2 p-2 rounded-lg bg-muted/30">
          <div className="w-8 h-8 rounded-full skeleton-shimmer" />
          <div className="flex-1 space-y-1">
            <div className="h-2 w-full rounded skeleton-shimmer" />
            <div className="h-3 w-1/3 rounded skeleton-shimmer" />
          </div>
          <div className="w-16 h-6 rounded-full skeleton-shimmer" />
        </div>
        
        {/* Availability */}
        <div className="pt-3 border-t border-border space-y-3">
          <div className="flex items-center justify-between">
            <div className="h-3 w-20 rounded skeleton-shimmer" />
            <div className="h-3 w-16 rounded skeleton-shimmer" />
          </div>
          
          {/* CTA Button */}
          <div className="h-10 w-full rounded-lg skeleton-shimmer" />
        </div>
      </div>
    </div>
  );
});

SkeletonCard.displayName = "SkeletonCard";

export default SkeletonCard;
